import React, { useContext, useEffect, useState } from "react";
import styles from "./UpdateWhatsapp.module.css";
import whatsappLike from "../../assests/whatsappLike.svg";
import singinCloseButton from "../../assests/singinCloseButton.svg";
import success from "../../assests/share/copySuccessRound.svg";
import copyLinkImage from "../../assests/share/copyLinkBlack.svg";
import copySuccess from "../../assests/share/copySuccessBlack.svg";
import { useUserAuth } from "../../context/UserAuthContext";
import Context from "../../context/Context";

const UpdateWhatsapp = ({ setPopup, type }) => {
  useEffect(() => {
    document.body.style.overflow = "hidden";
    return () => {
      document.body.style.overflow = "unset";
    };
  }, []);
  const { setUpdateData } = useContext(Context);
  const { userDetailsFromApi } = useUserAuth();
  const [copied, setCopied] = useState(false);
  const [messageSented, setMessageSented] = useState(false);

  let message = `#updatePhoneNumber, 

I would like to change my phone number.

requestId:US${userDetailsFromApi?.userId}`;

  const handleWhatsappLike = () => {
    let phoneNumber = "+918618406454";
    const encodedContent = encodeURIComponent(message);
    const isMobile = /Android|iPhone|iPad|iPod/i.test(navigator.userAgent);
    if (isMobile) {
      const url = `https://wa.me/${phoneNumber}?text=${encodedContent}`;
      window.open(url, "_blank");
    } else {
      const url = `https://web.whatsapp.com/send?phone=${phoneNumber}&text=${encodedContent}`;
      window.open(url, "_blank");
    }
    setTimeout(setMessageSented(true), 2000);
  };
  function copyLink() {
    setCopied(true);
    setTimeout(() => {
      setCopied(false);
    }, [1000]);
    navigator.clipboard.writeText(message);
    window.document.execCommand("copy");
  }

  const handleClose = () => {
    setPopup(false);
    setUpdateData((prev) => prev + 1);
  };
  return (
    <div className={styles.mainDiv}>
      <div className={styles.container}>
        <div className="w-[100%] flex justify-end p-[10px] cursor-pointer">
          <img src={singinCloseButton} onClick={handleClose} />
        </div>

        <h3 className="text-regular-medium mb-[14px]">
          {type == "update" ? "Update Whatsapp Number" : "Vote via Whatsapp"}
        </h3>

        <div className="w-full">
          <p className="text-small text-center mb-[5px]">
            Copy and sent below text to Whatsapp number +918618406454
          </p>
          <div className="w-full">
            <div
              className="flex flex-row items-center justify-between cursor-pointer w-[100%] p-[10px] border-[1px] border-slate-400 rounded-[8px]"
              onClick={copyLink}
              tooltip="Copy to clipboard"
            >
              <p className="text-small break-words text-[#858585] w-[90%]">
                {message}
              </p>
              <div className="w-[10%]">
                {copied ? (
                  <img src={copySuccess} className="w-[20px] h-[20px]" />
                ) : (
                  <img src={copyLinkImage} className="w-[20px] h-[20px]" />
                )}
              </div>
            </div>
          </div>
        </div>
        <p className="text-regular my-[20px]">OR</p>
        {messageSented ? (
          <p className="text-small text-opacity-80 mb-[25px] flex items-center gap-[5px]">
            <img src={success} alt="" className="w-[36px] h-[36px]" />
            Changes will be reflected soon in the profile
          </p>
        ) : (
          <div className={`px-[20px] ${styles.whatsappLogin}`}>
            <button
              className={`${styles.button} text-relugar-medium bg-[#7AC280]   flex items-center justify-center gap-[14px] drop-shadow-lg`}
              onClick={handleWhatsappLike}
            >
              <img src={whatsappLike} alt="" className="h-[24px] w-[24px]" />
              Take me to Whatsapp
            </button>
          </div>
        )}
      </div>
    </div>
  );
};

export default UpdateWhatsapp;
